import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=1b1ea6c3&scoped=true&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=1b1ea6c3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1ea6c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b1ea6c3')) {
      api.createRecord('1b1ea6c3', component.options)
    } else {
      api.reload('1b1ea6c3', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=1b1ea6c3&scoped=true&", function () {
      api.rerender('1b1ea6c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vendor/Pagination.vue"
export default component.exports